
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.037 11.293C8.239 8.591 12.374 6.81 14.443 5.95c5.908-2.458 7.135-2.884 7.935-2.899.176-.003.57.04.825.248.215.174.274.41.302.576.029.165.064.543.036.837-.32 3.364-1.705 11.527-2.41 15.294-.298 1.595-.886 2.13-1.454 2.181-1.235.114-2.173-.816-3.37-1.6-1.872-1.228-2.93-1.992-4.747-3.19-2.1-1.383-.74-2.144.458-3.387.313-.326 5.756-5.276 5.861-5.726.014-.056.026-.265-.099-.376-.124-.11-.307-.072-.44-.042-.188.042-3.179 2.02-8.973 5.93-.849.583-1.618.868-2.307.853-.76-.017-2.22-.43-3.307-.783-1.332-.433-2.39-.662-2.299-1.397.048-.383.576-.775 1.583-1.176z","fill":"#fff"}})])
          )
        }
      }
    